import { supabase } from './supabase';
import { ArticleGenerationCall } from '../types/articleGeneration';

export const aiService = {
  generateArticle: async (params: ArticleGenerationCall) => {
    return await supabase.functions.invoke('article-generation', {
      body: params,
    });
  },

  generateChat: async (params: {
    messages: { role: string; content: string }[];
    tone_of_voice: string;
    companyId: string;
    customer_group_description: string;
    language: string;
    domain_name: string;
  }) => {
    return await supabase.functions.invoke('chat', {
      body: params,
    });
  },

  generateNewsletter: async (params: {
    hasUrl: boolean;
    articleUrls: string[];
    prompt: string;
    draftIndex: number;
    language: string;
    toneOfVoice: string;
    customerGroupDescription: string;
    companyId: string;
    domainName: string;
    customPrompt?: string;
  }) => {
    return await supabase.functions.invoke('newsletter', {
      body: params,
    });
  },

  generateAd: async (params: {
    articleUrl: string;
    prompt: string;
    draftIndex: number;
    language: string;
    toneOfVoice: string;
    customerGroupDescription: string;
    adPlatform: string;
    companyId: string;
    domainName: string;
  }) => {
    return await supabase.functions.invoke('ad-generation', {
      body: params,
    });
  },

  generateSocialPosts: async (params: {
    platform: string;
    articleUrl: string;
    hasUrl: boolean;
    sourceText?: string;
    language: string;
    toneOfVoice: string;
    customerGroup: {
      name: string;
      description?: string;
    };
    companyId: string;
    domainName: string;
    customPrompt?: string;
  }) => {
    return await supabase.functions.invoke('social-posts', {
      body: params,
    });
  },

  generateProductDescriptions: async (params: {
    language: string;
    toneOfVoice: string;
    customerGroupDescription?: string;
    domainName?: string;
    categoryDescription?: string;
    productDetails: {
      productUrl: string;
      categoryUrl: string;
      language: string;
      toneOfVoice: string;
      customerGroupDefinition?: string;
      brandTextAmount: number;
      categoryTextAmount: number;
    };
    brandAmount: number;
    categoryAmount: number;
    brandTextAmount?: string;
    categoryTextAmount: string;
    brandDescription?: string;
    brandToneOfVoice?: string;
    count: number;
    section: string;
    companyId: string;
  }) => {
    return await supabase.functions.invoke('product-descriptions', {
      body: params,
    });
  },

  generateCategoryDescriptions: async (params: {
    url: string;
    section: string;
    language: string;
    toneOfVoice: string;
    customerGroupDescription: string;
    companyId: string;
    contentLength: number;
  }) => {
    return await supabase.functions.invoke('category-descriptions', {
      body: params,
    });
  },

  // Lists OpenRouter's full model catalog (keyless). Used by the super-admin AI-models page to
  // offer valid provider/model ids to add to the vetted list.
  listModels: async () => {
    return await supabase.functions.invoke<{
      models: { id: string; name: string; supported_parameters: string[] }[];
    }>('list-models');
  },
};
